import Formatter from 'src/class/Formatter';
import i18n from 'src/i18n';
import Tables from 'src/class/Tables';

const configTable = () =>{
    const Table = { ...Tables.Table };
    Table.tableColumns = [
        {
            prop: 'farm_name',
            label: i18n.t('common_words.farm'),
            minWidth: 80,
            align: 'left',
            sortable: true,
        },
        {
            prop: 'date_save',
            label: i18n.t('common_words.date'),
            minWidth: 80,
            align: 'center',
            sortable: true,
        },
        {
            prop: 'lot_name',
            label: i18n.t('common_words.allotment'),
            minWidth: 80,
            align: 'center',
            sortable: true,
        },
        {
            prop: 'crop_variety_name',
            label: i18n.t('common_words.crop_variety'),
            minWidth: 80,
            align: 'left',
            sortable: true,
        },
        {
            prop: 'reason_rejection_name',
            label: i18n.t('sowing.reason_rejection'),
            minWidth: 80,
            align: 'left',
            sortable: true,
        },
        {
            prop: 'total_plants_seeds_pruning',
            label: i18n.t('sowing.total_plants_seeds_planted_pruning'),
            minWidth: 80,
            align: 'center',
            sortable: true,
            formatter: (row) => {
                return Formatter.formatNumber(
                    row.total_plants_seeds_pruning
                );
            },
        },
        {
            prop: 'area',
            label: i18n.t('sowing.pruned_area')+'(Ha)',
            minWidth: 80,
            align: 'center',
            formatter: (row) => {
                return Formatter.formatNumber(
                    row.area
                );
            },
        },
    ];
    const Search = { ...Tables.Search };

    return { Table, Search };
}

export default configTable;